import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BaseModalProps, TextScreenModal as BaseTextScreenModal } from '@blend/consumer-components';
import * as textScreenAPI from 'login-apis/textScreenAPI';
import * as deploymentConfig from 'login-utils/deploymentConfig';

import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import TextViewer from '../TextViewer/TextViewer';
import './TextScreenModal.scss';

const organizationColors = deploymentConfig.getOrganizationColors();

interface State {
  isLoading: boolean;
  textScreenContent: string;
  textScreenError: string | undefined;
}

interface TextScreenModalProps extends BaseModalProps {
  textScreenId?: string;
  textScreenContent?: string;
}

const styles = StyleSheet.create({
  loadingSpinner: {
    display: 'flex',
    justifyContent: 'center',
  },
});

class TextScreenModal extends React.Component<TextScreenModalProps, State> {
  constructor(props: TextScreenModalProps) {
    super(props);
    this.state = {
      textScreenContent: '',
      isLoading: true,
      textScreenError: undefined,
    };
  }

  async componentDidMount() {
    const { textScreenId, textScreenContent } = this.props;
    this.setState({ isLoading: true });

    try {
      this.setState({
        isLoading: false,
        textScreenContent: textScreenContent || (textScreenId && (await textScreenAPI.getTextScreen(textScreenId))),
        textScreenError: undefined,
      });
    } catch (err) {
      this.setState({
        isLoading: false,
        textScreenContent: '',
        textScreenError: 'Apologies, we are having some trouble loading your content right now.',
      });
    }
  }

  render() {
    const { textScreenId, textScreenContent: textScreenContentProp, ...modalProps } = this.props;
    const { isLoading, textScreenContent, textScreenError } = this.state;

    return (
      <BaseTextScreenModal
        {...modalProps}
        minHeight={500}
        color={organizationColors.action}
        className="TextScreenModal"
      >
        <div>
          {isLoading && (
            <div className={css(styles.loadingSpinner)}>
              <LoadingSpinner />
            </div>
          )}
          {(textScreenContent || textScreenError) && (
            <TextViewer htmlText={textScreenContent} error={textScreenError} />
          )}
        </div>
      </BaseTextScreenModal>
    );
  }
}

export default TextScreenModal;
